
<template>    
  <div class="home">
    <NavBar />
    <div class="container d-flex flex-column align-items-center">
      <table class="dark-table">
        <tbody>
            <tr>
                <th>E-Mail</th>
                <th>Assessment</th>
                <th>Dispatch Code</th>
                <th>Time Limit</th>
            </tr>
            <tr v-for="assessment in this.dispatched">
                <td>{{ assessment.dispatchEmail }}</td>
                <td>{{ assessment.assessmentName }}</td>
                <td>{{ assessment.dispatchCode }}</td>
                <td>{{ formatTimeFromSeconds(assessment.timeLimit) }}</td>
            </tr>
            <tr v-if="this.dispatched && this.dispatched < 1">
                <td colspan="7" class="empty-candidates">No dispatched assessments.</td>
            </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>
<script>
import NavBar from '@/components/NavBar.vue'
import { endpoint } from '@/utils/endpoint/endpointUtils';
import { getCookie, deleteAllCookies } from '@/utils/cookies/cookieUtils';
import { formatTimeFromSeconds } from '@/utils/time';

export default {
  name: 'DispatchedView',
  components: {
      NavBar
  },
  data() {
    return {
        dispatched: []
    }
  },
  mounted() {
    this.fetchDispatchedForUserId();
  },
  methods: {
    async fetchDispatchedForUserId() {
        try {
            const userid = getCookie('userid');
            const token = getCookie('token');
            const response = await fetch(endpoint + '/api/Assessments/GetDispatchedFromUser?userId=' + userid, {
            method: 'GET',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json',
            }});

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            this.dispatched = data.dispatches;
            console.log(this.dispatched);            
        } catch(exception) { 
          deleteAllCookies();
          console.log(exception);
        }
    }, 
    formatTimeFromSeconds(seconds) {
      if (seconds === null || seconds < 1) {
        return 'None';
      }
      return formatTimeFromSeconds(seconds);
    }
  }
}
</script>
<style scoped>
.home {
    margin: 0;
    padding: 0;
    background-image: url('../assets/home-background.png'); /* Replace 'path/to/your/image.jpg' with the path to your image */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.dashboard {
    margin: 0;
    padding: 0;
    background-color: #181a1b;
}



@media screen and (max-width: 576px) {
  .dark-table {
    min-width: 200px;
  }
}

.empty-candidates {
    /* Set background image */
    background-image: url('../assets/empty-candidates.png');

    /* Adjust background properties */
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    height: 300px;
}


</style>